// STEP STUDIO-OVERLAY-UX-FIX-1-STEP2 · 테스트 모드 로컬 타이머 (backend/timer_actions.py 와 동일 규칙 · 서버 호출 0).
const nowIso = () => new Date().toISOString();
const clampLabel = (s) => (String(s || '').replace(/[<>&"']/g, '').trim().slice(0, 24) || '타이머');
const remainingOf = (t) => (t?.end_at ? Math.max(0, Math.ceil((Date.parse(t.end_at) - Date.now()) / 1000)) : 0);

export const applyTimerLocal = (prev, action, { duration_seconds, label } = {}) => {
  const b = prev || {};
  const now = nowIso();
  if (action === 'start') {
    const d = Math.max(1, Math.min(10800, parseInt(duration_seconds, 10) || 1));
    return { label: clampLabel(label ?? b.label), status: 'running', duration_seconds: d, remaining_seconds: d,
             end_at: new Date(Date.now() + d * 1000).toISOString(), visible: true, updated_at: now };
  }
  if (action === 'pause') {
    if (b.status !== 'running') return b;
    const r = remainingOf(b);
    return { ...b, status: r > 0 ? 'paused' : 'finished', remaining_seconds: r, end_at: null, updated_at: now };
  }
  if (action === 'resume') {
    if (b.status !== 'paused') return b;
    const r = parseInt(b.remaining_seconds || 0, 10);
    if (r <= 0) return { ...b, status: 'finished', remaining_seconds: 0, end_at: null, updated_at: now };
    return { ...b, status: 'running', end_at: new Date(Date.now() + r * 1000).toISOString(), updated_at: now };
  }
  if (action === 'reset') {
    const d = parseInt(b.duration_seconds || 1, 10);
    return { label: clampLabel(b.label), status: 'paused', duration_seconds: d, remaining_seconds: d,
             end_at: null, visible: b.visible !== false, updated_at: now };
  }
  if (action === 'stop') {
    return { label: clampLabel(b.label), status: 'idle', duration_seconds: parseInt(b.duration_seconds || 0, 10),
             remaining_seconds: 0, end_at: null, visible: b.visible !== false, updated_at: now };
  }
  if (action === 'hide' || action === 'show') return { ...b, visible: action === 'show', updated_at: now };
  return b;
};

// 새로고침 복원 — running 은 남은 시간으로 일시정지 상태 (재개 버튼으로만 재시작).
export const restoreTimerPaused = (t) => {
  if (!t || t.status !== 'running') return t || null;
  const r = remainingOf(t);
  return { ...t, status: r > 0 ? 'paused' : 'finished', remaining_seconds: r, end_at: null };
};

// EgressTemplate timerView 와 동일 계산.
export const timerViewOf = (timer, nowMs) => {
  if (!timer || timer.visible === false || timer.status === 'idle' || timer.status === 'hidden') return null;
  let remaining = 0;
  if (timer.status === 'running' && timer.end_at) {
    const end = Date.parse(timer.end_at);
    if (!Number.isNaN(end)) remaining = Math.max(0, Math.ceil((end - nowMs) / 1000));
  } else if (timer.status === 'paused' || timer.status === 'finished') {
    remaining = Math.max(0, parseInt(timer.remaining_seconds || 0, 10));
  }
  const mm = String(Math.floor(remaining / 60)).padStart(2, '0');
  const ss = String(remaining % 60).padStart(2, '0');
  return { label: timer.label || '타이머', display: `${mm}:${ss}`, status: remaining <= 0 ? 'finished' : timer.status };
};
